export const childCareKeyPrefix =
  'descriptions.admin-portal.workshops.details.child-care';
export const childCareTableKeyPrefix = childCareKeyPrefix.concat('.table');
export const childCareActionsKeyPrefix = childCareKeyPrefix.concat('.actions');
